// @flow

import React from 'react';

import BooleanInput from '../BooleanInput/BooleanInput';

type ChangeDescription = {
  name: string,
  value: string,
  checked: boolean,
};

// These props should exactly mirror those found in '../BooleanInput/BooleanInput'.
// Unforutunately Stylguidist will not detect the prop annotations and auto-generate
// documentation from them if the prop types are imported from another file. :-(
type Props = {
  /** True if the radio button should be checked. */
  checked: boolean,
  /** True if the radio button should render in an indeterminate state. */
  indeterminate?: boolean,
  /** The form field name. */
  name?: string,
  /** The form field id. */
  id?: string,
  /** True if the radio button should be disabled. */
  disabled?: boolean,
  /** The form field value. */
  value?: string,
  /** Callback to be fired when the radio button receives focus. */
  onFocus?: (event: SyntheticInputEvent<HTMLInputElement>) => void,
  /** Callback to be fired when the radio button loses focus. */
  onBlur?: (event: SyntheticInputEvent<HTMLInputElement>) => void,
  /**
   * Callback to be fired when the radio button is checked or unchecked. Receives
   * an object of the following format:
   * `{ name: props.name, value: props.value, checked: props.checked }`.
   */
  onChange?: (changed: ChangeDescription) => void,
  /** HTML aria-label property. */
  'aria-label'?: string,
  /** HTML aria-labelledby property. */
  'aria-labelledby'?: string,
  /** HTML aria-required property. */
  'aria-required'?: string,
};

/**
 * A trusty radio button.
 */
const RadioButton = (props: Props) => <BooleanInput {...props} type="radio" />;

export default RadioButton;
